import { MainComponent } from './common/components/main/main.component';
import { Routes } from '@angular/router';

export const routes: Routes = [
  // {
  //   path: '',
  //   pathMatch: 'full',
  //   redirectTo: 'main',
  // },
  {
    path: 'main',
    component: MainComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'competitionGroups',
      },
      {
        path: 'competitionGroups',
        loadChildren: () => import('./sections/competition-group/competition-group.routing')
          .then((m) => m.routes),
      },
      {
        path: 'user',
        loadChildren: () => import('./sections/user-profile/user-profile.routing')
          .then((m) => m.routes),
      },
      {
        path: 'tourManagement',
        loadChildren: () => import('./sections/tour-management/tour-management.routing')
          .then((m) => m.routes),
      },
      {
        path: 'competitionGroupInvite',
        loadChildren: () => import('./sections/comp-group-invite/comp-group-invite.routing')
          .then((m) => m.routes),
      },
    ],
  },
  {
    path: 'landing',
    loadChildren: () => import('./sections/landing/landing.routing')
      .then((m) => m.landingRoutes),
  },
  {
    path: '**',
    redirectTo: 'main',
  },
];
